import { ChangeEvent } from 'react';
import { PageableResponse } from '../../../../models/response.model';
import {
  ILancamentoAulasTableDTO
} from '../../../../models/happy-code-api.model';
import GenericPageableTable
  from '../../../../components/GenericPageableTable/generic-pageable-table.component';
import { useNavigate } from 'react-router-dom';
import { isAfterDate } from '../../../../util/format';
import dayjs from 'dayjs';
import { Tags } from '../../../../components/Tags';
import { getAulaNumero } from './functions/get-aula-numero.function';
import { useTranslation } from 'react-i18next';
import useSidebarComponentState from '../../../../components/Sidebar/useSidebarComponentState';

interface AulasTableProps {
  aulasTableData: PageableResponse<ILancamentoAulasTableDTO>;
  onPageChange: (event: ChangeEvent<unknown>, page: number) => void;
  page: number;
}

export default function AulasTable({
                                     aulasTableData,
                                     onPageChange,
                                     page
                                   }: AulasTableProps) {
  const navigate = useNavigate();
  const { t } = useTranslation('gestao_de_aulas');
  const {isComercial} = useSidebarComponentState();
  

  const isNaoOcorrida = (item: ILancamentoAulasTableDTO) =>
    item?.statusAula === 'NAO_OCORRIDA' || item?.naoOcorrida;

 const label = (item: ILancamentoAulasTableDTO) =>
    item?.isAulaLancada ? t('gestao_de_aulas:edit') : t('gestao_de_aulas:launch');

  const onClick = (item: ILancamentoAulasTableDTO) => {
    return item?.isAulaLancada
      ? navigate(`/turmas/professor/lancamento-aula/edit/${item?.aulaId}`)
      : navigate(
        `/turmas/professor/lancamento-aula/create/step-1/${item?.aulaId}`
      );
  };

  const getConteudoMinistrado = (item: ILancamentoAulasTableDTO) =>
    item?.conteudo || item?.descricao || '-';

    return (
    <GenericPageableTable
      data={aulasTableData}
      columns={[
        {
          key: 'nome',
          title: t('gestao_de_aulas:lessonName'),
          render: (item) =>
            `${t('gestao_de_aulas:lesson')} ${getAulaNumero(page, aulasTableData, item)}`
        },
        {
          key: 'data',
          title: t('gestao_de_aulas:date'),
          render: (item) => dayjs(item?.data).format('DD/MM/YYYY')
        },
        {
          key: 'possuiLancamento',
          title: t('gestao_de_aulas:status'),
          render: (item) => (
            <Tags
              tipo={
                isNaoOcorrida(item)
                  ? 'nao_ocorrida'
                  : item?.isAulaLancada ? 'lancado' : 'pendente'
              }
            />
          )
        },
        {
          key: 'conteudoMinistrado',
          title: t('gestao_de_aulas:contentTaught'),
          render: (item) => getConteudoMinistrado(item)
        },
        {
          key: 'alunosPresentes',
          title: t('gestao_de_aulas:presentStudents')
        },
        {
          key: 'alunosFaltosos',
          title: t('gestao_de_aulas:absentStudents')
        }
      ]}
      rowActions={[
        {
          disabled: isComercial ? true : false,
          label: label,
          conditionToRender: (item) =>
            !isNaoOcorrida(item) && (!item.isAulaLancada || isAfterDate(item.data)),
          onClick: isComercial ? () => {} : onClick
        }
      ]}
      onPageChange={onPageChange}
    />
  );
}
